import Vue from 'vue';
import ediOrderTransformer from './../../transformers/ediOrder';
import orderTransformer from './../../transformers/order';
import store from './../../store';

const success = (data) => {
  store.dispatch('fetchCurrentOrder', orderTransformer.fetch(data));
  Vue.router.push({
    name: 'orders.edit',
    params: {
      id: data.id,
    },
  });
};

export default (id, ediOrder) => (
  new Promise((resolve, reject) => {
    Vue.$http
      .post(`edi_orders/${id}/invoice`, ediOrderTransformer.send(ediOrder))
      .then((response) => {
        success(response.data);
        resolve();
      })
      .catch(() => {
        reject();
      });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/ediOrder/invoice.js